import React from 'react';
import TextField from '@mui/material/TextField';
import withAutoFill from './withAutoFill';
import InputAdornment from '@mui/material/InputAdornment';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiInputBase-input': {
      padding: '6px 10px 7px'
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.54)',
      padding: 0,
      fontSize: '0.8571428571428571rem',
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: 1,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#004C6A',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#004C6A',
    },
  },
}));

const helperUseStyles = makeStyles(() => ({
  helperText: {
    lineHeight: 1.1,
    letterSpacing: 0,
  },
}));

const Password = ({ input, inputId, handleInputs, style = {}, autoComplete, value }) => {
  const classes = useStyles();
  const helperClasses = helperUseStyles();

  const InputProps = {};

  if (input.icon) {
    InputProps.startAdornment = (
      <InputAdornment position="start">{input.icon}</InputAdornment>
    );
  }

  let required = input.hasOwnProperty("yup");

  if (input.hasOwnProperty("required")) {
    required = input.required;
  }

  return (
    <TextField
      variant="standard"
      classes={classes}
      error={input.error}
      key={inputId}
      name={inputId}
      type="password"
      value={value || ''}
      required={required}
      label={input.label}
      autoComplete={autoComplete || input.autoComplete}
      onChange={handleInputs}
      helperText={input.error && input.errorMessage}
      inputProps={{
        required: false,
      }}
      InputProps={InputProps}
      FormHelperTextProps={{
        className: helperClasses.helperText,
      }}
    />
  );
}

export default withAutoFill(Password);